import { Column } from 'react-table';

import { IProjectUsageTableData } from './TranslateTableView.interfaces';

import { ExternalLink } from '../../../../ExternalLink';

const TABLE_COLUMNS_TEXT_SPEECH: ReadonlyArray<Column<IProjectUsageTableData>> = [
  {
    accessor: 'action',
    Cell: ({ value }) => <div>{value}</div>,
    Header: () => <div>Feature</div>,
  },
  {
    accessor: 'dateLocaleDateString',
    Cell: ({ value }) => <div>{value}</div>,
    Header: () => <div>Date</div>,
  },
  {
    accessor: 'dateLocaleTimeString',
    Cell: ({ value }) => <div>{value}</div>,
    Header: () => <div>Time</div>,
  },
  {
    accessor: 'sourceLanguage',
    Cell: ({ value }) => <div>{value}</div>,
    Header: () => <div>Source</div>,
  },
  {
    accessor: 'targetLanguage',
    Cell: ({ value }) => <div>{value}</div>,
    Header: () => <div>Target</div>,
  },
  {
    accessor: 'referer',
    Cell: ({ value }) => <ExternalLink href={value} isTooltipVisible />,
    Header: () => <div>Referrer</div>,
  },
  {
    accessor: 'characters',
    Cell: ({ value }) => <div>{value}</div>,
    Header: () => <div>Characters</div>,
  },
  {
    accessor: 'apiKeyTitle',
    Cell: ({ value }) => <div>{value}</div>,
    Header: () => <div>API key</div>,
  },
];

export { TABLE_COLUMNS_TEXT_SPEECH };
